<template>    
    <v-container fluid>   

        <!-- Work title -->
        <v-col :alvqa="alvqa + '-title'">
            <v-row class="pl-4 headline">
                {{ item.title }}
            </v-row>
        </v-col>

        <!-- Original Shares -->
        <v-row class="pl-4 pr-4">
            <v-col>
                <v-data-table         
                    :headers="originalSharesHeaders"
                    hide-default-footer
                    :items="item.originalInterestedParties[getShareType.value] === null ? 
                                [] : item.originalInterestedParties[getShareType.value]
                            "
                    :no-data-text="$t('lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')"
                    style="background-color: var(--v-expandPanelBackground-base);"
                    class="noMinWidth"
                    :header-props="{ sortIcon: '' }"
                    :items-per-page="itemsPerPage"
                >
                    <template v-slot:top>
                        <v-container class="ml-0" style="background-color: var(--v-expandPanelBackground-base);">
                            <v-row>
                                <v-col class="headline" :alvqa="alvqa + '-headline-original-shares'">
                                    {{ $t("lang_PUBLISHING_WORKS_CAPTION_ORIGINAL_SHARES") }}
                                    <v-chip
                                        v-for="(item, index) in percentages"
                                        :key="index"
                                        @click="changePercentages(item)"
                                        :color="item.value === getShareType.value ? 'selectedChip' : 'standard'"
                                        class="ml-2 pl-4 pr-4"
                                        role="button"
                                        tabindex="0"
                                    ><div :alvqa="alvqa + '-original-shares-percentage-chip-' + item.value">{{ item.text }}</div></v-chip>
                                </v-col>
                            </v-row>
                        </v-container>
                    </template>
                    
                    <!-- Headers -->
                    <template v-for="(header, i) in originalSharesHeaders" v-slot:[`header.${header.value}`]>
                        <span :alvqa="header.alvqa" :key="i">{{ header.text }}</span>
                    </template>

                    <!-- Items -->
                    <template v-slot:[`item.name`]="{ item }">

                        <div v-if="(item.role != 'E' && item.role != 'SE') || getShareType.value != 'manu'" class="ellipsis">
                            <BaseTooltip 
                                :alvqa="alvqa +'-list-row-' + item.id + '-' + item.role + '-text-name'"
                            >
                                <template v-slot:content>
                                    <span>{{ getAzEntityName(item) }}</span>
                                </template>
                                <template v-slot:text>
                                    {{ getAzEntityTooltip(item) }}
                                </template>
                            </BaseTooltip>
                        </div>


                        <div v-if="(item.role != 'E' && item.role != 'SE') || getShareType.value != 'manu'" class="ellipsis subtitleGray--text">
                           
                            <BaseTooltip
                            :alvqa="alvqa +'-list-row-' + item.id + '-' + item.role + '-text-ipi'"
                            >
                                <template v-slot:content>
                                    <span class="subtitleGray--text">
                                        {{ item.ipi && item.ipi + ' | ' }} <router-link v-if="$alvPlugin.createUrlForAlvId(item.azEntity.alvId)" :to="$alvPlugin.createUrlForAlvId(item.azEntity.alvId)" target="_blank">{{ item.azEntity.alvId }}</router-link><span v-else>{{ item.azEntity.alvId }}</span>
                                    </span>
                                </template>
                                <template v-slot:text>
                                    {{ item.ipi && item.ipi + ' | ' }} {{ item.azEntity.alvId }} 
                                </template>
                            </BaseTooltip>
                        </div>
                    </template>

                    <template v-slot:[`item.pwr`]="{ item }">
                        <div v-if="(item.role != 'E' && item.role != 'SE') || getShareType.value != 'manu'" :alvqa="alvqa +'-list-row-' + item.id + '-' + item.role + '-text-pwr'">
                            {{ getPwrCommaSeparated(item.pwr) }}
                        </div>
                    </template>

                    <template v-slot:[`item.pmr`]="{ item }">
                        <div v-if="(item.role != 'E' && item.role != 'SE') || getShareType.value != 'manu'" :alvqa="alvqa +'-list-row-' + item.id + '-' + item.role + '-text-pmr'">
                            {{ showPmr(item.pmr) }}
                        </div>
                    </template>

                    <template v-slot:[`item.role`]="{ item }">
                        <div v-if="(item.role != 'E' && item.role != 'SE') || getShareType.value != 'manu'" :alvqa="alvqa +'-list-row-' + item.id + '-' + item.role + '-text-role'">
                            {{ item.role }}
                        </div>
                    </template>

                    <template v-slot:[`item.ctrl`]="{ item }">
                        <div v-if="(item.role != 'E' && item.role != 'SE') || getShareType.value != 'manu'" :alvqa="alvqa +'-list-row-' + item.id + '-' + item.role + '-text-ctrl'">
                            {{ item.ctrl === true ? $t('lang_GENERAL_YES') : $t('lang_GENERAL_NO') }} 
                            <!-- <v-icon>fa-check-square-o</v-icon> 
                            -o is not working, only without o...
                            https://fontawesome.com/v4.7.0/icon/check-square-o
                            https://fontawesome.com/icons?d=gallery&q=check-square
                            -->
                         </div>
                    </template>

                    <!-- <template v-slot:[`item.territory`]="{ item }">
                        <BaseTooltip>
                            <template v-slot:content>
                                <div :alvqa="alvqa +'-list-row-' + item.id + '-' + item.role + '-text-region'">
                                    {{ item.territory }}
                                </div>
                            </template>
                            <template v-slot:text>
                                {{ getRegionName(item.territory) }}
                            </template>
                        </BaseTooltip>
                    </template> -->
                    <!-- <template v-slot:[`item.contracts`]="{ item }">
                        <div :alvqa="alvqa +'-list-row-' + item.id + '-' + item.role + '-text-contracts'">
                            {{ item.contracts }}
                        </div>
                    </template> -->

                    <template v-slot:[`item.info`]="{ item }">
                        <div v-if="(item.role != 'E' && item.role != 'SE') || getShareType.value != 'manu'">
                            {{ getInfoCol(item) }}
                        </div>
                    </template>

                    <template v-slot:[`item.societyPrMr`]="{ item }">
                        <div v-if="(item.role != 'E' && item.role != 'SE') || getShareType.value != 'manu'" class="ellipsis">
                            <BaseTooltip 
                                :simpleText="showSocietyNames(item.prSociety, item.mrSociety)"
                                :alvqa="alvqa +'-list-row-' + item.id + '-' + item.role + '-text-society-pr-mr'"
                            />
                        </div>
                    </template>

                    <!-- Number formatting for all percentages -->
                    <template v-slot:[`item.prPercent`]="{ item }">
                        <div :alvqa="alvqa +'-list-row-' + item.id + '-' + item.role + '-text-percent-' + getShareType.value + '-pr'">
                            {{ $alvPlugin.getNumberLocalization(item.prPercent, 'number') }}
                        </div>
                    </template>
                    <template v-slot:[`item.mrPercent`]="{ item }">
                        <div :alvqa="alvqa +'-list-row-' + item.id + '-' + item.role + '-text-percent-' + getShareType.value + '-mr'">
                            {{ $alvPlugin.getNumberLocalization(item.mrPercent, 'number') }}
                        </div>
                    </template>
                    <!-- ********* SUM ROW ********* -->
                    <template slot="body.append" v-if="showSumRow">
                        <tr> 
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td 
                                align="left" 
                                class="data-table-sum-row"
                                :alvqa="alvqa + '-sum-row-text-sum'"
                            >
                                {{ $t('lang_GENERIC_CAPTION_SUM') }}
                            </td>
                            <!-- PR Sum Column -->
                            <td 
                                align="right" 
                                class="data-table-sum-row"
                                :alvqa="alvqa + '-sum-row-pr-col'"
                            >

                                <!-- No PR sum entered show N.N. -->
                                <div v-if="item.originalInterestedParties[getShareType.value].length === 0 || sumField('prPercent') === null">
                                    {{ $t("lang_GENERIC_CAPTION_NOMEN_NOMINANDUM") }}
                                </div>
                                <!-- PR Sum above 100 -->
                                <div
                                    v-else-if="sumField('prPercent') !== '100.00'"
                                    id="not100"
                                >
                                    {{ $n(sumField('prPercent'),"number") }}
                                </div>
                                <!-- Show PR sum value -->
                                <div v-else>
                                    {{ $n(sumField('prPercent'),"number") }}
                                </div>
                            </td>
                            <!-- MR Sum Column -->
                            <td 
                                align="right" 
                                class="data-table-sum-row" 
                                :alvqa="alvqa + '-sum-row-mr-col'"
                            >
                                <!-- No MR sum entered show N.N. -->
                                <div v-if="item.originalInterestedParties[getShareType.value].length === 0 || sumField('mrPercent') === null">
                                    {{ $t("lang_GENERIC_CAPTION_NOMEN_NOMINANDUM") }}
                                </div>
                                <!-- MR Sum above 100 -->
                                <div 
                                    v-else-if="sumField('mrPercent') !== '100.00'"
                                    id="not100"
                                >
                                    {{ $n(sumField('mrPercent'),"number") }}
                                </div>
                                 <!-- Show MR sum value -->
                                <div v-else>
                                    {{ $n(sumField('mrPercent'),"number") }}
                                </div>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>

        <!-- Cards -->
        <v-row class="pl-4 pr-4">
            <v-col cols="12" :md="cardCols.typ">
                <v-card elevation="0">
                    <v-card-text>
                        
                        <!-- TYPE -->
                        <span v-if="item.type !== null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-type'"
                            >{{ $t('lang_PUBLISHING_WORKS_CAPTION_TYPE') }}:</div>
                            <div
                                
                                :alvqa="alvqa + '-type'"
                            >{{ getType(item.type) }}</div>
                        </span>

                        <!-- FREE ROLESPLIT MUSIC / TEXT -->
                        <span v-if="item.freeRoleSplitMusic !== null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-free-rolesplit'"                            
                            >{{ $t('lang_PUBLISHING_WORKS_CAPTION_FREE_ROLESPLIT') }}:</div>
                            <div
                                :alvqa="alvqa + '-free-rolesplit'"
                            >{{ $n(getFreiV) }} / {{ calculateFreeRoleSplitText(getFreiV) }}</div>
                        </span>


                        <!-- STATUS -->
                        <span v-if="item.status !== null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-status'"                            
                            >{{ $t('lang_PUBLISHING_WORKS_CAPTION_STATUS') }}:</div>
                            <div
                                
                                :alvqa="alvqa + '-status'"
                            >{{ $t($alvPlugin.getStatus(item.status)) }}</div>
                        </span>

                        <!-- STATUS -->
                        <span v-if="item.registrationId !== null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-registration-id'"                            
                            >{{ $t('lang_PUBLISHING_WORKS_CAPTION_REGISTRATION_ID') }}:</div>
                            <div
                                :alvqa="alvqa + '-registration-id'"
                            >{{ item.registrationId }}</div>
                        </span>

                        <!-- REGISTRATION DATE (from GEMA) -->
                        <span v-if="item.registrationDate !== null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-registrationDate'"
                            >{{ $t('lang_PUBLISHING_WORKS_CAPTION_SUBMISSION_DATE') }}:</div>
                            <div
                                
                                :alvqa="alvqa + '-registrationDate'"
                            >{{ $d(new Date(item.registrationDate), 'alvDateFormat') }}</div>
                        </span>
                        <!-- LAST UPDATED -->
                        <span v-if="item.lastUpdated !== null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-last-updated'"
                            >{{ $t('lang_PUBLISHING_WORKS_CAPTION_LAST_UPDATED') }}:</div>
                            <div
                                
                                :alvqa="alvqa + '-last-updated'"
                            >{{ $d(new Date(item.lastUpdated), 'alvDateFormat') }}</div>
                        </span>
                        <!-- NOTIFICATION DATE -->
                        <span v-if="item.notificationDate !== null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-notification-date'"
                            >{{ $t('lang_GENERAL_CAPTION_NOTIFICATION_DATE') }}:</div>
                            <div
                                
                                :alvqa="alvqa + '-notification-date'"
                            >{{ $d(new Date(item.notificationDate), 'alvDateFormat') }}</div>
                        </span>
                    </v-card-text>
                </v-card>
            </v-col>
            <!-- TAGS -->
            <v-col cols="12" :md="cardCols.tags" v-if="item.tags !== null">
                <v-card elevation="0">
                    <v-card-text>
                        <div
                            class="read-only-caption"
                            :alvqa="alvqa + '-caption-tags'"
                        >{{ $t('lang_PUBLISHING_WORKS_CAPTION_TAGS') }}:</div>
                        <div
                            
                            :alvqa="alvqa + '-tags'"
                        >{{ item.tags }}</div>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="12" :md="cardCols.tracks" v-if="item.isrc !== null || item.linkedTracksReleases.tracks !== null || item.linkedTracksReleases.trackAlbums !== null">
                <v-card elevation="0">
                    <v-card-text>
                        <!-- LINKED TRACKS + RELEASES -->
                        <span v-if="item.linkedTracksReleases.tracks !== null || item.linkedTracksReleases.trackAlbums !== null">
                            <div
                                class="read-only-caption mb-3"
                                :alvqa="alvqa + '-caption-linked-tracks-releases'"
                            >{{ $t('lang_PUBLISHING_WORKS_CAPTION_LINKED_TRACKS_RELEASES') }}:</div>
                            <div
                                v-for="(track, i) in item.linkedTracksReleases.tracks"
                                :key="track.alvId"
                                class="mb-4"
                                style="border-left: 3px solid var(--v-logo-base); padding-left: 12px;"
                                :alvqa="alvqa + '-track-block-' + track.alvId"
                            >
                                <div :alvqa="alvqa + '-linked-tracks-releases-track-info'">
                                    <div>{{ track.track_name }}<template v-if="track.isrc"> | {{ track.isrc }}</template></div>
                                    <div class="mb-2">({{ $t('lang_GENERIC_CAPTION_OPEN_TRACK') }}: <a :href="`/label/tracks/${track.alvId}`" target="_blank">{{ track.alvId }}</a>)</div>
                                </div>
                                <div
                                    v-for="release in item.linkedTracksReleases.trackAlbums[i]"
                                    :key="release.alvId"
                                    class="ml-6"
                                    :alvqa="alvqa + '-linked-tracks-releases-release-info'"
                                >
                                    <div>{{ release.vo_name }}<template v-if="release.ean || release.katalog_nr"> | <template v-if="release.ean">EAN {{ release.ean }}</template><template v-if="release.ean && release.katalog_nr">, </template><template v-if="release.katalog_nr">{{ release.katalog_nr }}</template></template></div>
                                    <div class="mb-2">({{ $t('lang_GENERIC_CAPTION_OPEN_RELEASE') }}: <a :href="`/label/releases/${release.alvId}`" target="_blank">{{ release.alvId }}</a>)</div>
                                </div>
                            </div>
                        </span>
                        <!-- ISRC -->
                        <span v-if="item.isrc !== null">
                            <div
                                v-if="item.isrc.manual !== null"
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-isrc'"
                            >{{ $t('lang_CAPTION_ADDED_MANUALLY_ISRC') }}:</div>
                            <div
                                v-if="item.isrc.manual !== null"
                                :alvqa="alvqa + '-isrc'"
                            >{{ item.isrc.manual }}</div>
                        </span>
                    </v-card-text>
                </v-card>
            </v-col>
            <!-- v-if="showSecondCard" -->
            <v-col cols="12" :md="cardCols.sprache">
                <v-card elevation="0">
                    <v-card-text>
                        <!-- LANGUAGE -->
                        <span v-if="item.language !== null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-language'"
                            >{{ $t('lang_PUBLISHING_WORKS_CAPTION_LANGUAGE') }}:</div>
                            <div
                                
                                :alvqa="alvqa + '-language'"
                            >{{ getLanguage(item.language) }}</div>
                        </span>
                        <!-- STYLE -->
                        <span v-if="item.style !== null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-style'"
                            >{{ $t('lang_PUBLISHING_WORKS_CAPTION_STYLE') }}:</div>
                            <div
                                
                                :alvqa="alvqa + '-style'"
                            >{{ item.style }}</div>
                        </span>
                        <!-- ISWC -->
                        <span v-if="item.iswc !== null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-iswc'"
                            >{{ $t('lang_GENERIC_CAPTION_ISWC') }}:</div>
                            <div
                                
                                :alvqa="alvqa + '-iswc'"
                            >{{ item.iswc }}</div>
                        </span>
                        <!-- DURATION -->
                        <span v-if="item.duration !== null && item.duration !== '00:00' && item.duration !== ''">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-duration'"
                            >{{ $t('lang_PUBLISHING_WORKS_CAPTION_DURATION') }}:</div>
                            <div
                                                   
                                :alvqa="alvqa + '-duration'"
                            >{{ item.duration }}</div>
                        </span>
                        <!-- LEADING PUBLISHER -->
                        <span v-if="item.leadingPublisher !== null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-leading-publisher'"
                            >{{ $t('lang_PUBLISHING_WORK_LEADING_PUBLISHER') }}:</div>
                            <div
                                
                                :alvqa="alvqa + '-leading-publisher'"
                            >{{ getLeadingPublisher(item.leadingPublisher) }}</div>
                        </span>
                        <!-- WORK POINTS -->
                        <span v-if="item.workPoints !== null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-work-points'"
                            >{{ $t('lang_PUBLISHING_WORKS_CAPTION_WORK_POINTS') }}:</div>
                            <div
                                
                                :alvqa="alvqa + '-work-points'"
                            >{{ item.workPoints }}</div>
                        </span>
                        <!-- BACK COLLECTION -->
                        <span v-if="item.backCollection !== null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-back-collection'"
                            >{{ $t('lang_PUBLISHING_WORKS_CAPTION_BACK_COLLECTION') }}:</div>
                            <div
                                
                                :alvqa="alvqa + '-back-collection'"
                            >{{ $t(getBackCollection(item.backCollection)) }}</div>
                        </span>
                        <!-- OLD MR SPLIT -->
                        <span v-if="item.oldMrSplit !== null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-old-mr-split'"
                            >{{ $t('lang_PUBLISHING_WORKS_CAPTION_OLD_MR_SPLIT') }}:</div>
                            <div
                                
                                :alvqa="alvqa + '-old-mr-split'"
                            >{{ $t(getOldMrSplit(item.oldMrSplit)) }}</div>
                        </span>
                        <!-- CATALOGUE NR -->
                        <span v-if="item.catalogueNumber !== null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-catalogue-number'"
                            >{{ $t('lang_PUBLISHING_WORKS_CAPTION_CATALOGUE_NUMBER') }}:</div>
                            <div
                                
                                :alvqa="alvqa + '-catalogue-number'"
                            >{{ item.catalogueNumber }}</div>
                        </span>
                    </v-card-text>
                </v-card>
            </v-col>
            <!-- NOTES -->
            <v-col cols="12" :md="cardCols.notes" v-if="item.notes !== null">
                <v-card elevation="0">
                    <v-card-text>
                        <div
                            class="read-only-caption"
                            :alvqa="alvqa + '-caption-notes'"
                        >{{ $t('lang_GENERAL_CAPTION_NOTES') }}:</div>
                        <div :alvqa="alvqa + '-notes'">{{ item.notes }}</div>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <!-- Panels -->
        <v-row>
            <v-col class="ml-4 mr-4">
                <v-expansion-panels multiple focusable tile flat>
                    <WorkContractsPanel :item="item" />
                    <WorkSocietySharesPanel 
                        v-for="(society, name, key) in item.workSocieties"
                        :key="key + '-' + name"
                        :society="society"
                        :societyCode="name"
                        :workAlvId="item.alvId"
                    />
                    <WorksInstrumentationPanel :workAlvId="item.alvId"/>
                    <WorkOtherTitlesPanel :workAlvId="item.alvId"/>
                    <WorkOtherPersonsPanel :workAlvId="item.alvId"/>
                    <WorkOtherIdsPanel :workAlvId="item.alvId"/>
                    <WorkDistributionsPanel :workAlvId="item.alvId"/>
                    <WorkSheetsAndProjectsPanel :workAlvId="item.alvId"/>
                </v-expansion-panels>
            </v-col>
        </v-row>
    </v-container> 
</template>

<script>
import BaseTooltip from '@/components/_base/BaseTooltip'
import BaseButton from '@/components/_buttons/BaseButton'

import WorkContractsPanel          from './_panels/0_contracts/WorkContractsPanel.vue'
import WorkSocietySharesPanel       from './_panels/1_societyshares/WorkSocietySharesPanel'
import WorksInstrumentationPanel    from './_panels/2_instrumentation/WorksInstrumentationPanel.vue'
import WorkOtherTitlesPanel         from './_panels/3_othertitles/WorkOtherTitlesPanel'
import WorkOtherPersonsPanel        from './_panels/4_otherpersons/WorkOtherPersonsPanel'
import WorkOtherIdsPanel            from './_panels/5_otherids/WorkOtherIdsPanel'
import WorkDistributionsPanel       from './_panels/6_distribution/WorkDistributionsPanel'
import WorkSheetsAndProjectsPanel   from './_panels/7_sheetsAndProjects/WorkSheetsAndProjectsPanel'

import { 
        DropdownPublishingWorksOldMrSplit,
        DropdownGenericYesNo,
        DropdownPublishingWorksTypes
    } 
from '@/assets/dropdowns/alvDropdowns.js'

export default {
    name: "WorkReadOnly",
    components: {
        BaseTooltip,
        BaseButton,
        WorkContractsPanel,
        WorkSocietySharesPanel,
        WorkOtherTitlesPanel,
        WorkOtherPersonsPanel,
        WorkOtherIdsPanel,
        WorkDistributionsPanel,
        WorkSheetsAndProjectsPanel,
        WorksInstrumentationPanel
    },
    props: {
        itemId: {
            type: Number
        }
    },
    data() {
        return {
            alvqa: 'publishing-works-list-row-' + this.itemId + '-read-only'
        }
    },
    computed: {
        itemsPerPage() { return this.$store.getters.getItemsPerPage },
        
        getShareType:{
            get()           {return  this.$store.getters.getWorkShareType},
            set(value)      {this.$store.commit("setWorkShareType",value)}   
        },
        
        originalSharesHeaders() {
            const headers = [
                {
                    text: this.$t("lang_PUBLISHING_WORKS_CAPTION_INTERESTED_PARTY"),
                    value: "name", 
                    align: "left", 
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + "-original-shares-header-name"
                },
                {
                    text: this.$t("lang_PUBLISHING_WORKS_CAPTION_ROLE"), 
                    value: "role", 
                    align: "left", 
                    width: "80px",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + "-original-shares-header-role"
                },
                {
                    text: this.$t("lang_GENERIC_CAPTION_CTRL"),
                    align: "left", 
                    value: "ctrl", 
                    width: "80px",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + "-original-shares-header-ctrl"
                },
                {
                    text: this.$t("lang_PUBLISHING_WORKS_CAPTION_UVZ"), 
                    align: "left", 
                    value: "pwr", 
                    width: "90px",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + "-original-shares-header-pwr"
                },
                {
                    text: this.$t('lang_GENERAL_PMR'),
                    value: "pmr",
                    align: "left",
                    width: "90px",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-pmr-payable-mr'
                },
                {
                    text: "Info", 
                    align: "left", 
                    value: "info", 
                    width: "80px",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + "-original-shares-header-info"
                },
                // {
                //     text: this.$t("lang_PUBLISHING_WORKS_DIALOG_CAPTION_REGION"), 
                //     align: "left", 
                //     value: "territory", 
                //     width: "110px",
                //     class: 'text-no-wrap',
                //     alvqa: this.alvqa + "-original-shares-header-region"
                // },
                // {
                //     text: this.$t("lang_PUBLISHING_WORKS_CAPTION_CONTRACTS"), 
                //     align: "left", 
                //     value: "contracts", 
                //     width: "100px",
                //     class: 'text-no-wrap',
                //     alvqa: this.alvqa + "-original-shares-header-contracts"
                // },
                {
                    text: this.$t('lang_PUBLISHING_WORKS_CAPTION_SOCIETY_PR_MR'), 
                    value: "societyPrMr",
                    align: "left",
                    width: "180px",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-society-pr-mr'
                },
                {
                    text: this.getShareTypePercentageTranslation + " " + this.$t("lang_PUBLISHING_CAPTION_PERFORMING_RIGHTS_ABBREVIATION"), 
                    align: "right", 
                    value: "prPercent", 
                    class: 'text-no-wrap', 
                    width: "120px",
                    sortable: false,
                    alvqa: this.alvqa + "-original-shares-header-" + this.getShareType.value + "-pr-percent"
                },
                {
                    text: this.getShareTypePercentageTranslation + " " + this.$t("lang_PUBLISHING_CAPTION_MECHANICAL_RIGHTS_ABBREVIATION"), 
                    align: "right", 
                    value: "mrPercent", 
                    class: 'text-no-wrap', 
                    width: "120px",
                    sortable: false,
                    alvqa: this.alvqa + "-original-shares-header-" + this.getShareType.value + "-mr-percent"
                }
            ]

            return headers
        },

        item() { 
            let item = this.$store.getters.getExpandedWorks.find(element => {
                return element.id === this.itemId
            })

            let originalInterestedParties = item.originalInterestedParties
            let sortedOriginalInterestedParties = this.$alvPlugin.sortingOriginalInterestedPartiesByRole(originalInterestedParties)
            item.originalInterestedParties = sortedOriginalInterestedParties

            item.contracts  = this.checkContracters(item)

            return item
        },

        percentages() {
            return [
                {text: this.$t('lang_GENERIC_CAPTION_MANU_PERCENT'), value: "manu"},
                {text: this.$t('lang_GENERIC_CAPTION_ROLE_PERCENT'), value: "role"},
                {text: this.$t('lang_GENERIC_CAPTION_INTL_PERCENT'), value: "intl"},
                {text: this.$t('lang_GENERIC_CAPTION_OWN_PERCENT'), value: "own"},
            ]
        },

        getShareTypePercentageTranslation() {
            return this.percentages.find((el) => el.value == this.getShareType.value).text
        },

        showSumRow(){
            // Check if selected shareType exists in original shares
            if (this.getShareType.value in this.item.originalInterestedParties) {
                // Do not display sum row if shareType is role or manu
                return !["role", "manu"].includes(this.getShareType.value) 
            }
            return false
        },
        getFreiV() {
            let freiVM = this.$store.getters.getWorkDetailsFreeRoleSplitMusic
            if (this.$i18n.locale == 'de') {
                return freiVM ? Number(freiVM.toString().replace(',', '.')) : freiVM
            }

            return freiVM
        },
        cardCols() {
            const tagsVisible = this.item.tags !== null
            const notesVisible = this.item.notes !== null
            const tracksVisible = this.item.isrc !== null
                || this.item.linkedTracksReleases.tracks !== null
                || this.item.linkedTracksReleases.trackAlbums !== null
            const count = 2
                + (tagsVisible ? 1 : 0)
                + (notesVisible ? 1 : 0)
                + (tracksVisible ? 1 : 0)
            if (count === 2) {
                return { typ: 6, tags: 12, tracks: 12, sprache: 6, notes: 12 }
            }
            if (count === 3 && tracksVisible) {
                return { typ: 3, tags: 12, tracks: 6, sprache: 3, notes: 12 }
            }
            if (count === 3) {
                return { typ: 4, tags: 4, tracks: 12, sprache: 4, notes: 4 }
            }
            if (count === 4) {
                return { typ: 3, tags: 3, tracks: 3, sprache: 3, notes: 3 }
            }
            return { typ: 2, tags: 2, tracks: 4, sprache: 2, notes: 2 }
        },

        connectedPublishingCompanies() {
            if (!this.item.contracts || this.item.contracts.length === 0) {
                return null
            }
            let companies = []
            for (let i = 0; i < this.item.contracts.length; i++) {
                let contract = this.item.contracts[i]
                if (contract.connectedCompanyName && !companies.includes(contract.connectedCompanyName)) {
                    companies.push(contract.connectedCompanyName)
                }
            }
            return companies.length > 0 ? companies : null
        },

    },
    methods: {
        sumField(column) {
            let listOfParties = this.item.originalInterestedParties
            let sum = null

            for (const party of listOfParties[this.getShareType.value]) {
                if(party[column] !== null){
                    sum += parseFloat(party[column]) 
                } 
            }

            return sum !== null ? sum.toFixed(2) : 0
        },
        getAzEntityName(item) {
            let name = ""
            const az = item.azEntity
            const hasGroup = az.group !== null && az.group !== ''
            const LATIN_ONLY = /^[\u0000-\u024F\u1E00-\u1EFF\u2000-\u206F\u20A0-\u20CF\u2100-\u214F\s\d\p{P}]*$/u

            const isPublisher = ['E', 'SE'].includes(item.role)

            if (isPublisher) {
                const groupIsNonLatin = hasGroup && !LATIN_ONLY.test(az.group)
                name = groupIsNonLatin ? az.group : az.gemaName
            }
            else if (hasGroup && az.typeOfAz !== 'P') {
                name = az.group
            }
            else if (az.firstName !== null && az.lastName !== null) {
                const nameStr = az.lastName + az.firstName
                const isNonLatin = !LATIN_ONLY.test(nameStr)
                if (isNonLatin || this.$i18n.locale === 'ja' || this.$i18n.locale === 'ko') {
                    const space = isNonLatin ? '\u3000' : ' '
                    name = az.lastName + space + az.firstName
                } else {
                    name = az.firstName + ' ' + az.lastName
                }
            }
            else {
                name = az.gemaName
            }
            name += ' (' +  this.$alvPlugin.getRolePosition(item.role, item.position) + ')'
            return name
        },

        getAzEntityTooltip(item) {
            const nn = 'N.N.'
            const group = item.azEntity.group || nn
            const firstName = item.azEntity.firstName || nn
            const lastName = item.azEntity.lastName || nn
            const gemaName = item.azEntity.gemaName || nn
            
            return this.$t('lang_AZ_PERSONS_CAPTION_COMPANY_GROUP_ARTIST_NAME') + ': ' + group + ' | ' +
                   this.$t('lang_AZ_PERSONS_CAPTION_FIRST_NAME') + ': ' + firstName + ' | ' +
                   this.$t('lang_AZ_PERSONS_CAPTION_LAST_NAME') + ': ' + lastName + ' | ' +
                   this.$t('lang_GENERIC_AZ_CAPTION_GEMA_NAME') + ': ' + gemaName
        },
        
        calculateFreeRoleSplitText(freiVM) {
            // let freiVM = this.$store.getters.getWorkDetailsFreeRoleSplitMusic
            if (freiVM == null || freiVM < 35.2 || freiVM > 80.2) {
                return "_"
            } else {
                let freiVT = 100.00-freiVM
                return this.$n(freiVT)
            }
        },

        getPwrCommaSeparated(pwrArr) {
            let pwr = []
            pwrArr.forEach(element => {
                pwr.push(element.role+element.position)
            });

            return pwr.join(', ')
        },
        showPmr(item) {
            if(item !== null){
                return item.role + item.position
            }else{
                return ''
            }
        },
        getContractDate(contractDate){
            let date = ''
            if(contractDate !== null && contractDate !== undefined && contractDate !== ''){
                date += ' | ' + this.$d(new Date(contractDate), 'alvDateFormat')
            }
            return date
        },

        getBackCollection(backCollectionValue) {
            return DropdownGenericYesNo.find(element => {
                return element.value === backCollectionValue
            }).text
        },

        getOldMrSplit(oldMrSplitValue) {
            return DropdownPublishingWorksOldMrSplit.find(element => {
                return element.value === oldMrSplitValue
            }).text
        },

        getLeadingPublisher(leadingPublisherId) { 
            let leadingPublishers = this.$store.getters.getLeadingPublishers
            let tmp = leadingPublishers.find(publisher => {
                return publisher.value === leadingPublisherId
            })
            return tmp ? tmp.text : ''
        },

        getInfoCol(item) {
            if (this.item.contracts) { // safeguard against contracts being "null" from BE
                let contract = this.item.contracts.find(contract => {
                    return contract.licensor.alvId === item.azEntity.alvId
                })
                if(contract === undefined) return ''
                else return contract.contractType
            } else return ''      
        },

        getType(statusValue) {
            let types = DropdownPublishingWorksTypes
            
            let match = types.find(type => {
                return type.value === statusValue
            })

            if(match === undefined) return ''
            else return this.$t(match.text)
        },

        getLanguage(langCode) {
            let languages = this.$store.getters['getLanguages' + this.$i18n.locale.toUpperCase()]

            if(languages) {
                let match = languages.find(lang => {
                    return lang.value === langCode
                })
                

                if(match === undefined) return ''
                else return match.text.charAt(0).toUpperCase() + match.text.slice(1).toLowerCase()
            }
        },

        changePercentages(item) { this.getShareType = item; },

        showSocietyNames(societyPr, societyMr) {
            let societyNameAr = this.$alvPlugin.getSocietyName(societyPr)
            let societyNameMr = this.$alvPlugin.getSocietyName(societyMr)

            if(societyNameAr == '' && societyNameMr === '') return ''
            else return societyNameAr + ' | ' + societyNameMr
        },
        // showSecondCard() {
        //     let showDuration = this.item.duration !== null && this.item.duration !== '00:00'
        //     let showStyle = this.item.style !== null
        //     let showLanguage = this.item.language !== null
        //     let showIswc = this.item.iswc !== null
        //     let showLeadingPublisher = this.item.leadingPublisher !== null
        //     let showWorkPoints = this.item.workPoints !== null
        //     let showBackCollection = this.item.backCollection !== null
        //     let showOldMrSplit = this.item.oldMrSplit !== null
        //     let showCatNr = this.item.catalogueNumber !== null
            
        //     if(showDuration || showStyle || showLanguage || showIswc || showWorkPoints || showBackCollection || showOldMrSplit || showCatNr || showLeadingPublisher) return true 
        //     else return false
        // }
        checkContracters(item){

            let listOfContracts = item.contracts

            // Object of interested parties in original shares by share type as key 
            let listOfOriginalInterestedParties = item.originalInterestedParties
            // Converted object to list of alvIds by share type
            let originalSharesIdsByShareType = {}

            // List of interested parties in society shares and separate Array for its alv ids
            let workSocieties = item.workSocieties
            let workSocietiesAndInterestedParties = {}

            //Extraction of alv ids of every interested party from original shares
            if(listOfOriginalInterestedParties !== null && listOfOriginalInterestedParties !== undefined){
                Object.keys(listOfOriginalInterestedParties).forEach(shareType => {
                    if (listOfOriginalInterestedParties[shareType].length) {
                        originalSharesIdsByShareType[shareType] = listOfOriginalInterestedParties[shareType].map(el => el.azEntity.alvId)
                    }
                })
            }
            if (workSocieties !== null && workSocieties !== undefined) {
                //Going through the list of work societies 
                Object.keys(workSocieties).forEach(society => {
                    if (workSocieties[society].parties.length) {
                        // Map society interested parties from object to alvId
                        workSocietiesAndInterestedParties[society] = workSocieties[society].parties.map(el => el.azEntity.alvId)
                    }
                })
            }
            /**
             * End result => {
             *      35 : [alvId, alvId...],
             *      80 : [alvId, alvId...]
             * }
             */

            /**
             * If there is any contracts in work, alv id of each contract will be searched in both previously 
             * defined arrays with alv ids of interested parties.
             * 
             * If alv id of the contract was not found, user will be informed by the text message in the tooltip
             */
            if(listOfContracts !== undefined && listOfContracts !== null){

                for (const workContract of listOfContracts) {
                    workContract.notInOriginalShares = {
                        missing: false,
                        inShareTypes: []
                    }
                    workContract.notInSocietyShares = {
                        missing: false,
                        inSociety: []
                    }

                    const availableShareTypes = Object.keys(originalSharesIdsByShareType)
                    if (availableShareTypes.length) {
                        let missingInShareTypes = []
                        for (const shareType of availableShareTypes) {
                            if (shareType === 'manu') {
                                continue; // Skip checking for 'manu' share type
                            }
                            if (!originalSharesIdsByShareType[shareType].includes(workContract.licensor.alvId)) {
                                // If it is not add to missingInShareTypes list
                                missingInShareTypes.push(shareType)
                            }
                        }
                        // If there are some share types then contractor is not in interested parties list for that share type
                        workContract.notInOriginalShares = {
                            missing: missingInShareTypes.length > 0, 
                            inShareTypes: missingInShareTypes
                        }
                    }


                    //Looping through previously defined workSocietiesAndInterestedParties
                    const availableSocieties = Object.keys(workSocietiesAndInterestedParties)
                    if (availableSocieties.length) {
                        let missingInSocieties = []
                        for (const society of availableSocieties) {
                            /**
                             * If contract was not found in one of the societies:
                             *  1) Society code will be pushed into temporary array of society codes (for ex. GEMA or SUISA or both or whatever...)
                             *     in which a particular contract was not found
                             */
                            if(!workSocietiesAndInterestedParties[society].includes(workContract.licensor.alvId)){
                                missingInSocieties.push(society)
                            }
                        }
                        // If there are some society codes then contractor is not in interested parties list for these society shares
                        workContract.notInSocietyShares = {
                            missing: missingInSocieties.length > 0,
                            inSociety: missingInSocieties
                        }
                    }
                }
            }

            //Contracts information will be updated 
            return listOfContracts
        },
    },
    mounted() {
        this.$store.commit('setCountries')
        this.$store.commit('setLanguages')
        this.$store.commit('setPublishingContractsTypes')
        this.$store.dispatch('fetchWorksProjectsSheets')
    }
}
</script>

<style>
    .noMinWidth table {
        min-width: 0px !important;
    }
    #not100{
        color:  var(--v-error-base)
    }

</style>